{
    "features-majority-account-get-paid-early": {
        "meta": {
            "title": "Recibe tu sueldo antes y evita cargos por sobregiro - MAJORITY",
            "description": "¿Quieres tu sueldo antes del viernes? ¡Recíbelo hasta dos días antes con MAJORITY! La App para enviar dinero sin cargos. Evita cualquier cargo por sobregiro."
        },
        "hero": {
            "title": "¡Recibe tu sueldo antes con nuestra App!",
            "body": "Recibe tu sueldo antes con nuestra app para enviar dinero y recargar a través del depósito directo anticipado en la app MAJORITY.",
            "cta": "Recibe tu sueldo antes"
        },
        "get_paid_early_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "Recibe tu sueldo 2 días antes",
            "body": "Ahora el día de pago es antes. Regístrate en el depósito directo anticipado en la app MAJORITY para que puedas recibir tu sueldo hasta dos días antes y evitar cualquier cargo por sobregiro. Nunca más esperes hasta el viernes para darte un gusto o pagar las cuentas. No necesitas enviar una solicitud para recibir tu sueldo antes.",
            "cta": "Comenzar"
        },
        "how_to_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "Cómo recibir tu sueldo antes",
            "body": "Es fácil recibir tu sueldo antes con la app para enviar dinero de MAJORITY. Simplemente descarga la app y sigue los siguientes pasos:\n+ Dirígete a \"Cuenta\"\n+ Pulsa \"Recibe tu sueldo antes\"\n+ Pulsa \"Configurarlo\"\n+ Pulsa \"Obtener formulario de depósito\"\n+ Imprime el formulario \n+ Responde las preguntas\n+ Firma el formulario \n+ Entrega el formulario de depósito directo a tu empleador\n+ ¡Recibe tu sueldo antes!",
            "cta": "Comenzar"
        },
        "more_than_paid_early_content_box": {
            "tagline": "Cuenta de MAJORITY",
            "title": "¿Buscas algo más que una app para enviar dinero o recibir tu sueldo antes?",
            "body": "No busques más. MAJORITY es una app a través de la que puedes recibir tu sueldo antes, pero también ofrece mucho más. Con una cuenta MAJORITY, puedes registrarte para el depósito directo anticipado sin tener que pagar ningún cargo por sobregiro o saldo mínimo. Además, recibirás una tarjeta de débito Visa® que te brinda acceso a descuentos exclusivos, puedes enviar dinero y hacer llamadas internacionales.",
            "cta": "Ver todos los beneficios",
            "canvas": "Ahorra más con MAJORITY"
        }
    }
    
}